import Contact from "./Contact";
import Limit from "./Limit";
import Location from "./Location";
import PersonalInfos from "./PersonalInfos";
import References from "./References";

const DebtorFormSections = {
  Contact,
  Location,
  Limit,
  PersonalInfos,
  References,
};

export default DebtorFormSections;
